import { render, staticRenderFns } from "./CustomersTableCard.vue?vue&type=template&id=3feaba2b"
import script from "./CustomersTableCard.vue?vue&type=script&lang=js"
export * from "./CustomersTableCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports